import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { Location } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormGroup, FormControl, FormGroup } from '@angular/forms';
import { SystemService } from '../../services/system.service'
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { GlobalsService } from '../../services/globals.service'
@Component({
	selector: 'app-mail',
	templateUrl: './mail.component.html',
	styleUrls: ['./mail.component.scss']
})
export class MailComponent implements OnInit {
	emailForm: UntypedFormGroup;
	vendorDiscForm: FormGroup;
	color = 'blue';
	constructor(
		private globalSearchService: GlobalSearchService,
		private systemService: SystemService,
		private globalsService: GlobalsService,
		private location: Location,
		private fb: UntypedFormBuilder,
		private route: ActivatedRoute,
		private router: Router,
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.vendorDiscForm = this.fb.group({
			enabled: [false],
			recipients: [''],
			notifyInvoiceVsPo: [true],
			notifyPpv: [true],
			notifyPqv: [true],
		});
		this.loadVendorDiscForm();

		this.route.queryParams.subscribe((params) => {
			if (params['oauth_ok']) {
				this.globalSearchService.showNotification('Microsoft Outlook authorization saved.', 'success', 'bottom', 'right');
				this.router.navigate([], { relativeTo: this.route, queryParams: {}, replaceUrl: true });
				this.loadForm();
			} else if (params['oauth_error']) {
				this.globalSearchService.showNotification('Microsoft authorization failed or was cancelled.', 'warning', 'bottom', 'right');
				this.router.navigate([], { relativeTo: this.route, queryParams: {}, replaceUrl: true });
			}
		});

		this.emailForm = this.fb.group({
			config_mail_parameter: [],
			config_mail_smtp_hostname: [],
			config_mail_smtp_username: [],
			config_mail_smtp_password: [],
			config_mail_smtp_port: [],
			config_mail_smtp_timeout: [],
			config_mail_engine: [],
			config_mail_alert_email: [],
			config_mail_smtp_auth: ['login'],
			config_mail_oauth_tenant_id: [],
			config_mail_oauth_client_id: [],
			config_mail_oauth_refresh_token: [],
		});

		this.loadForm();

	}

	loadVendorDiscForm() {
		this.globalsService.getVendorInvoiceDiscrepancyNotify().subscribe((r: any) => {
			if (!r) { return; }
			this.vendorDiscForm.patchValue({
				enabled: !!r.enabled,
				recipients: r.recipients || '',
				notifyInvoiceVsPo: r.notifyInvoiceVsPo !== false,
				notifyPpv: r.notifyPpv !== false,
				notifyPqv: r.notifyPqv !== false,
			});
		});
	}

	saveVendorDiscSettings() {
		const v = this.vendorDiscForm.value;
		this.globalsService.saveVendorInvoiceDiscrepancyNotify(v).subscribe((res: any) => {
			if (res && res.success) {
				this.globalSearchService.showNotification('Vendor invoice discrepancy settings saved.', 'success', 'bottom', 'right');
			} else {
				this.globalSearchService.showNotification('Could not save settings.', 'warning', 'bottom', 'right');
			}
		});
	}

	loadForm() {
		this.systemService.getEmailSettings().subscribe( (result: any) => {

			this.emailForm = this.fb.group({
				config_mail_parameter: [result.config_mail_parameter],
				config_mail_smtp_hostname: [result.config_mail_smtp_hostname],
				config_mail_smtp_username: [result.config_mail_smtp_username],
				config_mail_smtp_password: [result.config_mail_smtp_password],
				config_mail_smtp_port: [result.config_mail_smtp_port],
				config_mail_smtp_timeout: [result.config_mail_smtp_timeout],
				config_mail_alert_email:  [result.config_mail_alert_email],
				config_mail_engine: [result.config_mail_engine],
				config_mail_smtp_auth: [result.config_mail_smtp_auth || 'login'],
				config_mail_oauth_tenant_id: [result.config_mail_oauth_tenant_id],
				config_mail_oauth_client_id: [result.config_mail_oauth_client_id],
				config_mail_oauth_refresh_token: [result.config_mail_oauth_refresh_token],
			});
		});
	}

	startMicrosoftOAuth(): void {
		const returnUrl = `${window.location.origin}${window.location.pathname}#/system/email`;
		this.systemService.beginMailOAuth(returnUrl).subscribe((res: any) => {
			if (res && res.success && res.authorize_url) {
				window.location.href = res.authorize_url;
			} else {
				this.globalSearchService.showNotification((res && res.message) ? res.message : 'Could not start Microsoft sign-in.', 'warning', 'bottom', 'right');
			}
		});
	}

	saveEmailSettings() {
		if(this.emailForm.valid) {
			this.systemService.saveEmailSettings(this.emailForm.value).subscribe(result => {
				this.loadForm();
				this.globalSearchService.showNotification('Updated', 'success', 'bottom', 'right');
			});
		}
	}

	back(): void {
		this.location.back()
	}

	update() {

	}

}
